import type talentZh from '../zh/talent';

const talent: typeof talentZh = {
  title: 'Quảng trường KOL',
  search_placeholder: 'Tìm KOL / biệt danh',
  market: 'Thị trường',
  category: 'Danh mục',
  category_placeholder: 'Chọn danh mục',
  category_selected: 'Đã chọn',
  category_search: 'Tìm danh mục',
  all: 'Tất cả',
  market_vn: 'Việt Nam',
  market_th: 'Thái Lan',
  market_id: 'Indonesia',
  market_my: 'Malaysia',
  market_ph: 'Philippines',
  market_sg: 'Singapore',
  cat_beauty: 'Làm đẹp',
  cat_home: 'Nhà cửa',
  cat_fashion: 'Thời trang',
  cat_digital: 'Điện tử',
  cat_lifestyle: 'Phong cách sống',
  add_to_mine: 'Thêm vào KOL của tôi',
  select_required: 'Vui lòng chọn KOL trước',
  already_collected: 'KOL đã chọn đã được lưu',
  batch_outreach: 'Kết nối hàng loạt',
  batch_invite: 'Mời hàng loạt',
  my_talents: 'KOL của tôi',
  col_talent: 'KOL',
  followers: 'Người theo dõi',
  gmv30: 'GMV 30 ngày',
  email: 'Email',
  status: 'Trạng thái',
  status_pending: 'Chờ kết nối',
  status_replied: 'Đã trả lời',
  status_cooperated: 'Đã hợp tác',
  status_blacklist: 'Danh sách chặn',
  load_failed: 'Không tải được danh sách KOL',
  category_load_failed: 'Không tải được danh mục',
  col_actions: 'Thao tác',
  has_email: 'Có email',
  favorited: 'Đã lưu',
  favorite: 'Lưu',
  collect_success: 'Đã lưu',
  collect_failed: 'Không lưu được KOL',
  missing_open_id: 'Thiếu ID của KOL',
  outreach: 'Kết nối',
  target_invite: 'Lời mời định hướng',
  blacklist: 'Danh sách chặn',
  detail_title: 'Chi tiết KOL',
  detail_load_failed: 'Không tải được chi tiết KOL',
  pps_score: 'Điểm PPS',
  live_gmv: 'GMV livestream',
  video_gmv: 'GMV video',
  gmv_range: 'Khoảng GMV',
  units_sold_range: 'Khoảng sản lượng',
  avg_live_uv: 'UV livestream trung bình',
  avg_video_views: 'Lượt xem video trung bình',
  creator_level: 'Cấp KOL',
  audience: 'Chân dung người theo dõi',
  age_range: 'Độ tuổi chính',
  major_gender: 'Giới tính chính',
  gender_male: 'Nam',
  gender_female: 'Nữ',
  demographics: 'Chân dung gốc',
  official_recommend: 'Đề xuất chính thức',
  fast_growing: 'Tăng trưởng nhanh',
  collaborated: 'Đã hợp tác',
  invited_90d: 'Đã mời trong 90 ngày',
  creator_blocked: 'Đã bị chặn',
  flat_fee: 'Phí cố định',
  rising_star: 'Ngôi sao mới',
  privacy_creator: 'KOL riêng tư',
  original_creator: 'KOL nguyên bản',
  mcn: 'MCN',
  created_at: 'Thời gian tạo',
  updated_at: 'Thời gian cập nhật',
  match_score: 'Điểm phù hợp',
  start_outreach: 'Bắt đầu kết nối',
  view_emails: 'Xem thư trao đổi',
  block: 'Chặn',
  gmv7: 'GMV 7 ngày',
  coop_products: 'Sản phẩm hợp tác',
  content_count: 'Số nội dung',
  email_yes: 'Có',
  email_no: 'Không',
  why_fit: 'Vì sao phù hợp với bạn',
  why_fit_fallback:
    '{{name}} khớp danh mục cửa hàng hiện tại, người theo dõi tập trung ở Đông Nam Á. Nên ưu tiên email và lời mời định hướng.',
  timeline: 'Dòng thời gian hợp tác',
  no_record: 'Chưa có ghi nhận',
  timeline_empty_desc: 'Dòng thời gian tương tác sẽ hiện sau khi bạn bắt đầu kết nối.',
  products_title: 'Sản phẩm bán hàng',
  products_empty: 'Chưa có dữ liệu bán hàng',
  col_product: 'Sản phẩm',
  col_gmv: 'GMV',
  col_output: 'Nội dung'
};

export default talent;
